<template>
  <div class="was-developing">
    <div class="img">
      <img src="../../assets/images/components-img/zhengzaikaifa.png" alt="">
    </div>
    <p>
      功能正在开发 敬请等待
    </p>
  </div>  
</template>
<script>
export default {
  data(){
    return{

    }
  },
  components:{
  }
}
</script>
<style lang="less" scoped>
  .was-developing{
    .img{
      width: 5.15rem;
      height: 5.34rem;
      margin: 0 auto;
      img{
        width: 5.15rem;
        height: 5.34rem;
      }
    }
    p{
      text-align: center;
      margin-top: .76rem;
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(149,149,149,1);
    }
  }
</style>